/* tslint:disable */
/* eslint-disable */
export enum PersonalIdentificationType {
  Ine = 'INE',
  Ssn = 'SSN',
  Passport = 'Passport'
}
